const PostIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.56738 17.4748V6.43479L12.1674 0.914795L21.7674 6.43479V17.4748L12.1674 22.9948L2.56738 17.4748Z"
        fill="#1C7ED6"
      />
      <path
        d="M15.4947 2.86206L6.01367 8.33273L8.84028 9.96453L18.3213 4.49386L15.4947 2.86206Z"
        fill="#1C1D1F"
      />
      <path
        d="M5.94727 13.6484L8.76834 15.2636L8.78493 10.0419L5.94727 8.40454V13.6484Z"
        fill="#1C1D1F"
      />
      <path
        d="M21.7673 17.5425V6.45738L12.1701 0.914795L2.56738 6.45738V17.5425L12.1701 23.0851L21.7673 17.5425Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7671 6.45752L12.1699 12.0001"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.56738 6.45752L12.1646 12.0001"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1699 23.0851V12.011"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PostIcon;
